/* eslint-disable import/default */

require('es6-promise').polyfill();
import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import axios from 'axios';
import {find} from 'ramda';
import configureStore, { history } from './store/configureStore';
import {addAPIKeyToHeader, base_url} from './actions/race';
import Root from './components/Root';
import './styles/styles.scss';
import './styles/mobileStyles.scss';
import './styles/rr360.scss';

import {SET_ACCOUNT_ID, SET_ADS, SET_BRAND, SET_THEME, SET_SINGLE_EVENT, GET_RACE_DETAIL} from "./constants/actionTypes"; // Yep, that's right. You can import SASS/CSS files too! Webpack will run the associated loader and plug this into the page.
import {BRAND_CONFIG, ACCOUNT_CONFIG} from "./constants/BRAND_CONFIG";

require('./favicon.ico'); // Tell webpack to load favicon.ico
const store = configureStore();

const domElement = document.getElementById('RR-360_results');
const raceId = domElement.getAttribute('race-id');
let accountId = domElement.getAttribute('account-id');
let brand = domElement.getAttribute('brand');

if (window.location.hash.indexOf('accountId=') > -1) {
  accountId = getParameterByName('accountId', location.hash);
}
if (window.location.hash.indexOf('brand=') > -1) {
  brand = getParameterByName('brand', location.hash);
  if (brand.toLowerCase() === 'allsports') {
    accountId = 'allsports';
  }
}

const init = function(accountIdParam) {

  if (accountIdParam) {
    store.dispatch({type: SET_ACCOUNT_ID, accountId: accountIdParam});
  } else if (raceId) {
    store.dispatch({type: SET_ACCOUNT_ID, accountId: ''});
    axios.get(`${base_url}/${raceId}`, addAPIKeyToHeader(store.getState))
      .then((result) => {
          store.dispatch({
            type: GET_RACE_DETAIL,
            raceDetail: result.data
          });
          return init(result.data.account_id);
      });
  }



  const brandConfig = brand ? find(x => x.brand.toLowerCase() === brand.toLowerCase())(BRAND_CONFIG) : null;

  const accountConfig = accountIdParam ? find(x => x.accountId.toLowerCase() === accountIdParam.toLowerCase())(ACCOUNT_CONFIG) : null;

  // console.log(brandConfig);
  // console.log(accountConfig);
  let theme = {primaryColor: '#DE171F', secondaryColor: '#DE171F', logo: 'https://admin.cdn.raceresults360.com/rr360logo.png', headerHeight: 30};
  let ads = {type: 'adsense', showFull: true, showMobile: true};
  if (brandConfig) {
    ads = {type: brandConfig.config.ad, showFull: brandConfig.config.showFullAds, showMobile: brandConfig.config.showMobileAds};
    theme = brandConfig.theme || theme;
  } else if (accountConfig) {
    ads = {type: accountConfig.config.ad, showFull: accountConfig.config.showFullAds, showMobile: accountConfig.config.showMobileAds};
    theme = accountConfig.theme || theme;
  }
  // console.log(ads);
  store.dispatch({type: SET_ADS, ads});
  store.dispatch({type: SET_BRAND, brand: brand || 'RR360'});
  store.dispatch({type: SET_THEME, theme});
  store.dispatch({type: SET_SINGLE_EVENT, singleEvent: !!raceId});
};

init(accountId);

if (raceId && window.location.hash === '') {
  history.push(`#/race/${domElement.getAttribute('race-id')}`);
}

render(
  <AppContainer>
    <Root store={store} history={history} />
  </AppContainer>,
  domElement
);



if (module.hot) {
  module.hot.accept('./components/Root', () => {
    const NewRoot = require('./components/Root').default;
    render(
      <AppContainer>
        <NewRoot store={store} history={history} />
      </AppContainer>,
      domElement
    );
  });
}


function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}



// WEBPACK FOOTER //
// ./src/index.js